import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type"]

import { computed } from 'vue';
import FaIcon from '@/core/components/FaIcon.vue';

interface AppButtonProps {
	variant?: string,
	seamless?: boolean,
	small?: boolean,
	icon?: string,
	iconWeight?: string,
	type?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppButton',
  props: {
    variant: {},
    seamless: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    icon: {},
    iconWeight: { default: 'r' },
    type: { default: 'button' }
  },
  setup(__props: any) {

const props = __props;

const className = computed(() => {
	const classList: string[] = [];

	if (props.seamless) {
		classList.push('button-seamless');
	} else {
		classList.push('button');
	}

	if (props.small) {
		classList.push('button-sm');
	}

	if (props.variant) {
		classList.push(props.variant);
	}

	return classList;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(className.value),
    type: _ctx.type
  }, [
    _createElementVNode("span", null, [
      (_ctx.icon)
        ? (_openBlock(), _createBlock(FaIcon, {
            key: 0,
            icon: _ctx.icon,
            weight: _ctx.iconWeight
          }, null, 8, ["icon", "weight"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 10, _hoisted_1))
}
}

})